const STRIPE_STATUS = {
  NONE: 'NONE',
  NOT_STARTED: 'NOT_STARTED',
  LIMITED_SOON_WITH_PAYMENTS: 'LIMITED_SOON_WITH_PAYMENTS',
  LIMITED_SOON_PAYMENTS_ONLY: 'LIMITED_SOON_PAYMENTS_ONLY',
  LIMITED_WITHOUT_PAYMENTS: 'LIMITED_WITHOUT_PAYMENTS',
  LIMITED_PARTIALLY: 'LIMITED_PARTIALLY',
  REJECTED: 'REJECTED',
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING',
};

const EMPTY_STRIPE = [ null, STRIPE_STATUS.NONE, STRIPE_STATUS.NOT_STARTED, STRIPE_STATUS.REJECTED ];
const PENDING_STRIPE = [
  STRIPE_STATUS.PENDING,
  STRIPE_STATUS.LIMITED_SOON_WITH_PAYMENTS,
  STRIPE_STATUS.LIMITED_SOON_PAYMENTS_ONLY,
];

const STRIPE_LIMITED = [
  STRIPE_STATUS.LIMITED_SOON_WITH_PAYMENTS,
  STRIPE_STATUS.LIMITED_SOON_PAYMENTS_ONLY,
  STRIPE_STATUS.LIMITED_WITHOUT_PAYMENTS,
  STRIPE_STATUS.LIMITED_PARTIALLY,
];

const ACTION_REQUIRED = [
  STRIPE_STATUS.LIMITED_WITHOUT_PAYMENTS,
  STRIPE_STATUS.LIMITED_PARTIALLY,
];

const READY_STRIPE = [
  STRIPE_STATUS.ACTIVE,
  STRIPE_STATUS.LIMITED_SOON_WITH_PAYMENTS,
  STRIPE_STATUS.LIMITED_SOON_PAYMENTS_ONLY,
];

const FRONT_STRIPE_STATUS = {
  EMPTY: 'empty',
  PENDING: 'pending',
  ACTION_REQUIRED: 'action-required',
  READY: 'ready',
};

const INVOICE_STATUS = {
  OPEN: 'open',
  DRAFT: 'draft',
  PARTIALLY_PAID: 'partially_paid',
  PAID: 'paid',
  PAYMENT_OVERDUE: 'payment_overdue',
  UNRECOVERABLE: 'unrecoverable',
  VOID: 'void',
};

const SUBSCRIPTION_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  NO: 'no',
  TERMINATED: 'terminated',
};

const BILLING_DOCUMENT_TYPES = {
  INVOICE: 'invoice',
  DISCOUNT: 'discount',
  CREDIT_NOTE: 'credit_note',
};

const BILLING_DOCUMENT_INVOICE_TYPE = {
  ADAF_FEE: 'adaf_fee',
  SERVICE_FEE: 'service_fee',
  MANAGEMENT: 'management',
  FAILED_FEE: 'failed_fee',
  OTHER: 'other',
};

export {
  STRIPE_STATUS,
  EMPTY_STRIPE,
  PENDING_STRIPE,
  READY_STRIPE,
  ACTION_REQUIRED,
  FRONT_STRIPE_STATUS,
  INVOICE_STATUS,
  STRIPE_LIMITED,
  BILLING_DOCUMENT_TYPES,
  BILLING_DOCUMENT_INVOICE_TYPE,
  SUBSCRIPTION_STATUS,
};
